<template>
<div class="chapter">
<div class="inner_page">
<p class="C255"><a id="page_1">THE CRESCENT OBSCURED</a></p><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Halftitl.vue?4a75ab72